import * as J from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as so } from "../../helpers/edgeMask.js";
const ao = {
  name: "Chromatic3",
  collection: "chromatic",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (m) => {
    const {
      vec3: f,
      vec4: E,
      time: O,
      mix: n,
      sin: T,
      float: o,
      pow: c,
      uv: d,
      color: t
    } = J, r = t("#d150ff"), l = t("#36b8df"), N = t("#e023f4"), u = t("#2b80ff"), C = t("#0051ff"), S = t("#5aa7e6"), p = 0.5, I = 0.5, R = 0, D = -0.1, G = 0.12, A = 0.5, L = 30, g = 0.8, b = 0.03, Y = 0.5, F = 0.5, v = 0.6, w = 1, x = 2, U = 0.02, B = 0.1, s = d(), { correctedUV: V } = Z(), _ = oo(s, G, A, L), W = c(r, o(2.2)), h = c(l, o(2.2)), y = c(N, o(2.2)), k = c(u, o(2.2)), H = n(
      W,
      h,
      s.y
    ), P = n(
      k,
      y,
      s.x
    ), K = n(
      H,
      P,
      s.x
    ), a = _.x.sub(0.3), i = _.y.sub(0.5), M = i.mul(a).add(i.mul(a)).negate(), e = o(1).add(
      o(g).mul(
        T(
          M.add(O.mul(m.speed.uniform).mul(0.025)).div(b)
        )
      )
    ), Q = so({
      inset: p,
      softness: I,
      offsetX: R,
      offsetY: D
    }), X = f(e, e, e).mul(Q).mul(Y), z = n(
      S.mul(B),
      C.mul(U),
      s.y.mul(s.x)
    ), j = $(F)(V), q = E(
      z.add(K.mul(X)).sub(j),
      1
    );
    return to(q, r, v, w, x);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
